var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellnessOrangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66657 11.1127C5.54464 11.4364 5.00822 11.4364 4.88635 11.1127C4.53279 10.1728 3.95358 8.89068 3.20918 8.14627C2.4648 7.40186 1.18258 6.82257 0.242923 6.46909C-0.0809746 6.34716 -0.0809746 5.81079 0.242923 5.68886C1.18258 5.33539 2.4648 4.7561 3.20918 4.01168C3.95358 3.26727 4.53279 1.98512 4.88635 1.04552C5.00822 0.721566 5.54464 0.721566 5.66657 1.04552C6.02004 1.98512 6.59933 3.26727 7.34374 4.01168C8.08814 4.7561 9.37028 5.33538 10.3102 5.68886C10.6338 5.81079 10.6338 6.34716 10.3102 6.46909C9.37028 6.82257 8.08814 7.40186 7.34374 8.14627C6.59933 8.89068 6.02004 10.1728 5.66657 11.1127Z",
    fill: "#C2B58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessOrangeStar);
export default __webpack_public_path__ + "static/media/wellness-orange-star.f7fe82ff9d0b2dda030a05393878c011.svg";
export { ForwardRef as ReactComponent };